import isURL from 'validator/lib/isURL';
import { z } from 'zod';

const oauthUrlPattern = new RegExp(
  `^https://(${['login.medishare.com', 'okta.ccm.dev'].map((h) => h.replaceAll('.', String.raw`\.`)).join('|')})/oauth2/\\w+$`,
);

export const v = {
  ccmCoreApiKey: () => {
    return z.string().min(6).brand<'CcmCoreApiKey'>();
  },
  newRelicApiKey: () => {
    return z
      .string()
      .regex(/^NRAK-\w+$/)
      .brand<'NewRelicApiKey'>();
  },
  newRelicAppDomain: () => {
    return z
      .url()
      .regex(/^(https:\/\/prayerstream[.-]|https?:\/\/localhost(?::\d+)?)/);
  },
  newRelicAppId: () => {
    return z.string().regex(/^\d+$/).brand<'NewRelicAppId'>();
  },
  nodeEnv: () => {
    return z.enum(['development', 'test', 'production']);
  },
  oktaClientId: () => {
    return z.string().length(20);
  },
  oktaIssuer: () => {
    return z.string().regex(oauthUrlPattern);
  },
  port: () => {
    return z.coerce.number().int().min(1024).max(65_535);
  },
  publicUrl: () => {
    return z.union([
      z.string().refine((value) => {
        return (
          isURL(value, {
            allow_trailing_dot: false,
            protocols: ['http', 'https'],
            require_protocol: true,
            require_tld: false,
          }) && !value.endsWith('/')
        );
      }),
      z.literal(''),
      z.literal('.'),
    ]);
  },
  strictUrl: () => {
    return z.string().refine((value) => {
      return (
        isURL(value, {
          allow_trailing_dot: false,
          protocols: ['http', 'https'],
          require_protocol: true,
          require_tld: false,
        }) && !value.endsWith('/')
      );
    });
  },
  stringbool: () => {
    return z.stringbool({
      case: 'sensitive',
      falsy: ['false'],
      truthy: ['true'],
    });
  },
  taco: () => {
    return z.string().min(10);
  },
};
